<template>
  <v-card>
    <v-card-title class="subheading font-weight-bold">Experiência</v-card-title>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item>
        <v-list-item-content>NPS</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.nps">
          <span class="text-highlight" :style="{ color }">{{
            details.nps
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <!-- <v-list-item>
        <v-list-item-content>Classificação NPS</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.classificacao_nps"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.classificacao_nps
          }}</span>
        </v-list-item-content>
      </v-list-item>
      <v-divider /> -->
      <v-list-item>
        <v-list-item-content>Causa Raiz</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.causa_raiz">
          <span class="text-highlight" :style="{ color }">{{
            details.causa_raiz
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <!-- <v-list-item>
        <v-list-item-content>Comentário da Causa</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.comentario_da_causa"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.comentario_da_causa
          }}</span>
        </v-list-item-content>
      </v-list-item> -->

      <v-divider />

      <v-list-item>
        <v-list-item-content>Comentário Geral</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.comentario_geral"
        >
          <span class="text-highlight" :style="{ color }">{{
            details.comentario_geral
          }}</span>
        </v-list-item-content>
      </v-list-item>

      <!--
      <v-divider />

      <v-list-item>
        <v-list-item-content>Comentários</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.CAUSA_3">
          <span class="text-highlight" :style="{ color }">{{ details.CAUSA_3 }}</span>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "Information",

  props: {
    details: {
      type: Object,
      required: true,
    },
  },

  computed: {
    color() {
      return this.$vuetify.theme.dark
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary;
    },
  },

  filters: {
    date: (str) => new Date(str).toLocaleString(),
  },
};
</script>

<style scoped>
.v-list {
  max-height: 75vh;
  overflow: auto;
}

.text-highlight {
  display: contents;
}
</style>